module.exports = __webpack_public_path__ + "static/media/car-transmission-blue.97711165.svg";